import * as _ from "lodash";
import * as Backbone from "backbone";
import {BaseAnalyticsModalView, BaseAnalyticsModalViewOptions} from "../_BaseAnalyticsAppViews";
import {OrganizationCollection} from "../../../../collections/Organizations";
import {AnalyticsPermissionCollection} from "../../collections/AnalyticsPermissions";
import {GenericDeleteModal} from "../../../../views/modals/GenericDeleteModal";

export class ModifyAnalyticsGroupModal extends BaseAnalyticsModalView {
    template = _.template(require('../../templates/modals/modifyAnalyticsGroup.html'));

    analyticGroupId: number;

    constructor(options: BaseAnalyticsModalViewOptions) {
        super(<any>_.extend(options, {
            tagName: 'div',
            events: {
                'shown.bs.modal #addAnalyticGroupModal': 'handleModalShown',
                'hidden.bs.modal #addAnalyticGroupModal': 'handleModalHidden',
                'change .add-agroup-modal-app-select': 'handleOrgChange',
                'change .permission-checkbox': 'handlePermissionChange',
                'click .add-agroup-btn': 'handleAddButtonClick',

                'click .modify-agroup-btn': 'handleModifyButtonClick',
                'click .delete-agroup-btn': 'handleDeleteButtonClick',
                'input .add-agroup-modal-name': 'handleInputName'
            }
        }));
        // For the base class methods 
        this.modalIdSelector = 'addAnalyticGroupModal';

        this.options.organizationCollection = new OrganizationCollection(
            this.options.organizationCollection.filter((org) => {
                return Boolean(this.options.appCollection.findWhere({
                    organization_id: org.get('id'),
                    type: 'analytics',
                    enabled: 1
                }))
            }, this)
        );

        this.analyticGroupId = this.options.modelId;

        this.userGroupCollection = null;
        this.userGroupPermissionsCollections = {};

        this.handleInputName = _.debounce(this.handleInputName.bind(this), 100);
    }

    render() {
        var name = '';
        var appId = null;
        if (this.analyticGroupId) {
            var db = this.options.analyticsGroupCollection.findWhere({id: this.analyticGroupId});
            name = db.get('name');
            appId = db.get('app_id');
        }

        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            newAnalyticGroup: !this.analyticGroupId,
            analyticGroupId: this.analyticGroupId,
            permissionCollection: this.options.permissionCollection,
            appsCollection: this.options.appCollection,
            name: name,
            appId: appId
        }))

        return this;
    }

    handleOrgChange() {
        var appId = this.$('.add-agroup-modal-app-select').val();

        var app = this.options.appCollection.findWhere({ id: Number(appId) });
        var orgId = app.get('organization_id');

        // Load permissions & render toggle buttons
        $.when(this.loadPermissionsCollections(
            orgId,
            'canViewAnalyticsGroup',
            'canModifyAnalyticsGroup',
            'canDeleteAnalyticsGroup'
        ))
            .then(() => {
                this.$('.add-agroup-btn').prop('disabled', true);
                this.handleAddButtonDisabledState();
            });
    }

    handleInputName() {
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
        var canAssignPerms = false;
        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.$('.add-agroup-btn').prop('disabled', true);
                this.$('.modify-agroup-btn').prop('disabled', true);
                return;
            }

            // Only allow a new analytics group to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            }, this)
        }

        // Make sure the analytics meter group is named
        if (!this.$('.add-agroup-modal-name').val() || !canAssignPerms) {
            this.$('.add-agroup-btn').prop('disabled', true);
            this.$('.modify-agroup-btn').prop('disabled', true);
            return;
        }

        // Make sure at least one analytics meter group has all permissions
        var allPerms = _.some(this.$('.permission-modify').map(function () {
            return $(this).is(':checked')
        }));
        this.$('.add-agroup-btn').prop('disabled', !allPerms);
        this.$('.modify-agroup-btn').prop('disabled', !allPerms);
    }

    getNewPermissionCollection(usergroupId) {
        // Override base method in _BaseModifyModal
        return new AnalyticsPermissionCollection([], { userGroupId: usergroupId });
    }

    handleModifyButtonClick() {
        this.setFormSubmitted();

        $.ajax({
            type: "PUT",
            url: this.options.analyticsGroupCollection.url() + '/' + this.analyticGroupId,
            data: JSON.stringify({
                appId: Number(this.$('.add-agroup-modal-app-select').val()),
                name: this.$('.add-agroup-modal-name').val(),
                permissions: this.getPermissionsDict()
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: () => {
                this.refetchCollectionsAndShow(this.analyticGroupId)
            }
        });
    }

    handleDeleteButtonClick() {
        var agroup = this.options.analyticsGroupCollection.findWhere({id: this.analyticGroupId});
        var modal = new GenericDeleteModal({
            type: 'Analytics Group',
            name: agroup.get('name'),
            func: () => {
                this.setFormSubmitted();
                return $.when(agroup.destroy()).done(() => {
                    this.refetchCollectionsAndShow();
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleAddButtonClick() {
        this.setFormSubmitted();
        $.ajax({
            type: "POST",
            url: this.options.analyticsGroupCollection.url(),
            data: JSON.stringify({
                appId: Number(this.$('.add-agroup-modal-app-select').val()),
                name: this.$('.add-agroup-modal-name').val(),
                permissions: this.getPermissionsDict()
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.refetchCollectionsAndShow(response.analyticGroupId)
            }
        });
    }

    refetchCollectionsAndShow(analyticGroupId?) {
        var d1 = this.options.analyticsGroupCollection.fetch({reset: true});
        var d2 = this.options.permissionCollection.fetch({ reset: true });
        $.when(d1, d2).done(() => {
            this.hide();
            if (!analyticGroupId || analyticGroupId !== this.analyticGroupId) {
                window.location.hash = "#/analytics" + (analyticGroupId ? '/' + analyticGroupId : '');
            } else {
                Backbone.history.loadUrl();
            }
            
            window['App'].Bus.trigger('navigation:update');
        }).fail(() => {
            this.setFormError();
        })
    }

    show() {
        (<any>this.$('#addAnalyticGroupModal')).modal('show');
        this.handleOrgChange();
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/analytics/views/modals/ModifyAnalyticsGroup.ts